import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { RuheSanftApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Camera } from '@ionic-native/camera';

//Pages
import { InfoPage } from '../pages/info/info';
import { LoginPage } from '../pages/login/login';
import { DemoPage } from '../pages/demo/demo';
import { SterbefaellePage } from '../pages/sterbefaelle/sterbefaelle';
import { SterbefallPage } from '../pages/sterbefall/sterbefall';
import { TerminPage } from '../pages/termin/termin';
import { VerwandterPage } from '../pages/verwandter/verwandter';

//Components
import { CardCollapse } from '../components/card-collapse/card-collapse.component';
import { DateInput } from '../components/date-input/date-input.component';
import { ElternteilPanel } from '../components/elternteil-panel/elternteil-panel.component';
import { TerminInput } from '../components/termin-input/termin-input.component';
import { TextInput } from '../components/text-input/text-input.component';
import { TimeInput } from '../components/time-input/time-input.component';

//Pipes
import { PropertiesPipe } from '../pipes/properties.pipe';
import { ShortGermanDatePipe } from '../pipes/short-german-date.pipe';

//Providers
import { GuiProvider } from '../providers/gui.provider';
import { SterbefallProvider } from '../providers/sterbefall.provider';
import { UserProvider } from '../providers/user.provider';
import {ServerProvider} from "../providers/server.provider";
import {TestsPage} from "../pages/tests/tests";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

//Globale Variablen
export let apiVersion = "1.0";
export let defaultServerUrl = "https://eingabe.bestattungssoftware.de/api/";


@NgModule({
	declarations: [
		RuheSanftApp,
		//Pages
		InfoPage,
		LoginPage,
		DemoPage,
		SterbefaellePage,
		SterbefallPage,
		TerminPage,
		TestsPage,
		VerwandterPage,
		//components
		CardCollapse,
		DateInput,
		ElternteilPanel,
		TerminInput,
		TextInput,
		TimeInput,
		//Pipes
		PropertiesPipe,
		ShortGermanDatePipe
	],
	imports: [
		IonicModule.forRoot(RuheSanftApp, { backButtonText: 'Zurück' }),
		BrowserAnimationsModule,
		BrowserModule,
		HttpModule
	],
	bootstrap: [IonicApp],
	entryComponents: [
		RuheSanftApp,
		InfoPage,
		LoginPage,
		DemoPage,
		SterbefaellePage,
		SterbefallPage,
		TerminPage,
		TestsPage,
		VerwandterPage
	],
	providers: [
		BarcodeScanner,
		Camera,
		StatusBar,
		SplashScreen,
		GuiProvider,
		ServerProvider,
		SterbefallProvider,
		UserProvider,
		{provide: ErrorHandler, useClass: IonicErrorHandler}
	]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts